import React from "react";
import "./Location.css";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaUserTie } from "react-icons/fa";
import LuziraImage from "../Assets/Marth.webp";
import IgangaImage from "../Assets/Kira.webp";
import Img5 from '../Assets/deeeric.jpeg';

const LOCATIONS = [
  {
    name: "Luzira Campus",
    address: "Kitintale, Luzira, Kampala, Uganda",
    phone: "+256 704 083043",
    email: "info@thecitychurchluzira.org",
    description: "Our main campus with weekly services and community events.",
    image: LuziraImage,
    pastor: "Pastor Martha Banalya",
  },
  {
    name: "Kirinya Campus",
    address: "Kirinya, Kampala, Uganda",
    phone: "+256 787 464303",
    email: "info@thecitychurchluzira.org",
    description: "A growing campus with a focus on young adults and families.",
    image: Img5,
    pastor: "Pastors Derrick & Deborah Mooli",
  },
  {
    name: "Iganga Campus",
    address: "Iganga. Join us every Sunday",
    phone: "+256 705 510002",
    email: "info@thecitychurchluzira.org",
    description: "A welcoming community for worship and connection every week.",
    image: IgangaImage,
    pastor: "Pastors Simon & Lillian",
  },
];

export default function LocationsPage() {
  return (
    <section className="tcc-section locations" aria-labelledby="locations-heading">
      <div className="tcc-container">
        <div className="locations__head">
          <p className="tcc-eyebrow">Visit us</p>
          <h2 className="tcc-h2" id="locations-heading">Our Locations</h2>
          <p className="tcc-lead">Three campuses across Uganda. Find the one nearest you.</p>
        </div>

        <ul className="locations__grid">
          {LOCATIONS.map((loc) => (
            <li className="location-card tcc-card tcc-card--hover" key={loc.name}>
              <div className="location-card__media">
                <img src={loc.image} alt={`The City Church ${loc.name}`} className="location-card__img" loading="lazy" />
              </div>
              <div className="location-card__body">
                <h3 className="location-card__name">{loc.name}</h3>
                <p className="location-card__pastor">
                  <FaUserTie aria-hidden="true" /> {loc.pastor}
                </p>
                <p className="location-card__desc">{loc.description}</p>
                <ul className="location-card__meta">
                  <li><FaMapMarkerAlt aria-hidden="true" /> <span>{loc.address}</span></li>
                  <li><FaPhoneAlt aria-hidden="true" /> <a href={`tel:${loc.phone.replace(/\s/g, '')}`}>{loc.phone}</a></li>
                  <li><FaEnvelope aria-hidden="true" /> <a href={`mailto:${loc.email}`}>{loc.email}</a></li>
                </ul>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
